export { default } from './LabelBox'
export enum LabelBoxEnum {
  errorLight = 'errorLight',
  infoDark = 'infoDark',
  success = 'success',
  warning = 'warning',
  info = 'info',
  error = 'error',
  infoLight = 'infoLight',
}

export type LabelBoxEnumStr = keyof typeof LabelBoxEnum

export enum LabelBoxSizeEnum {
  sm = 'm',
  md = 'd',
}

export type LabelBoxSizeEnumStr = keyof typeof LabelBoxSizeEnum
